module.exports = __webpack_public_path__ + "images/landing-page-resources-mobile-bg.jpg";